module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img-41b973e1e957c1b869d8ae3f12b43899.png";